import { createContext, useContext } from "react";

export const LocalOverlayContext = createContext<HTMLElement | null>(null);

export const useLocalOverlay = () => useContext(LocalOverlayContext);
